import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=70482d53&"
import script from "./ShareButton.controller.js?vue&type=script&lang=js&"
export * from "./ShareButton.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ShareButton.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "3bc71bf3"
  
)

export default component.exports